import React from "react"

import {FieldPickerProps} from "../../../render/picker"
import HintPopover from "../../../../gd-ui/hint-popover/hint-popover"

// const debug = "FieldPopover_Picker"
const debug = false

export default class FieldPopover_Picker extends React.Component<FieldPickerProps,any> {

    public previousValue        : any

    constructor(props:FieldPickerProps) {
        super(props);

        const value = _.get(props.model, props.field.fieldId, null)

        debug && console.log(debug, 'constructor', value)

        this.state = {
            initialPropsValue   : value, // required to check if currentOptions update needed on props changed
            currentValue        : value,
            showPopover         : false,
        }
    }

    static getDerivedStateFromProps(props:any, state:any) {
        const value = props.model[props.field.fieldId] // new value

        if (!_.isEqual(value, state.initialPropsValue)) {
            return {
                initialPropsValue   : value,
                currentValue        : value
            }
        }

        return null // no changes
    }

    showPopover = () => {
        if (!this.state.showPopover) {
            this.setState({
                showPopover: true
            })
        }
    }

    hidePopover = () => {
        if (this.state.showPopover) {
            this.setState({
                showPopover: false
            })
        }
    }

    // for compatibility with dropdown PopoverMenu (BaseDropdownPopoverMenu)
    onOptionClick = (option:any) => {
        this.onValueChange(option ? option.value : option)
    }

    onValueChange = (value:any) => {
        debug && console.log(debug, 'onValueChange', value)

        this.previousValue = this.state.currentValue;
        const newValue = value; //_.get(option, 'value', null);

        this.setState({
            currentValue: newValue
        }, () => {
            this.props.onChange?.(newValue, this.onCancelChange);

            if (!this.props.field.fieldParams.keepPopoverOpenOnSelect) {
                this.hidePopover()
            }
        })
    }

    onCancelChange = () => {
        this.setState({
            currentValue: this.previousValue
        })
    }

    render() {
        const {field} = this.props

        const classes = Classes(this.props.className, {
            'show-popover' : this.state.showPopover,
        });

        const showHint = _.get(this.props.configOptions, 'showHint', true)

        // need check value because of none
        if (this.state.currentValue) {
            return (
                <field.components.PickerValueNotEmpty {...this.props}
                                                      className={classes}
                                                      field={this.props.field}
                                                      value={this.state.currentValue}
                                                      onClick={this.showPopover}
                                                      onChange={this.onValueChange}
                                                      options={this.props.options}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} value={this.state.currentValue} />}
                    {!this.state.showPopover && showHint && <HintPopover hint={this.props.field.label}/>}
                </field.components.PickerValueNotEmpty>
            )
        } else {
            return (
                <field.components.PickerValueEmpty {...this.props} className={classes} field={this.props.field} onClick={this.showPopover} options={this.props.options}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
                    {!this.state.showPopover && showHint && <HintPopover hint={this.props.field.label}/>}
                </field.components.PickerValueEmpty>
            )
        }
    }
}


